import { render, staticRenderFns } from "./ServiceSelection.vue?vue&type=template&id=31b4070f&scoped=true"
import script from "./ServiceSelection.vue?vue&type=script&lang=js"
export * from "./ServiceSelection.vue?vue&type=script&lang=js"
import style0 from "./ServiceSelection.vue?vue&type=style&index=0&id=31b4070f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4070f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlayMixSelectedServices: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/PlayMix/SelectedServices.vue').default,PlayMixServiceSelector: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/PlayMix/ServiceSelector.vue').default})
